export const hasContactPermissions = (email, contactPermissions) => {
  const contactPermission = contactPermissions && contactPermissions.get(email);
  return !contactPermission || contactPermission.canCommunicate;
};